import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./Pages/Login/login";
import Home from "./Pages/Home/home";
import { Provider } from "react-redux";
import store from "./ReduxStore/store";
import Signup from "./Pages/Signup/signup";
import ResetPassword from "./Pages/ResetPassword/resetPassword";
import ChangePassword from "./Pages/ChangePassword/changePassword";
import ResetVerification from "./Pages/ResetVerificationCode/resetVerification";
import LandingPage from "./Pages/Landing/landing";
import PrivacyPolicy from "./Pages/OtherPages/privacyPolicy";
import TermsConditions from "./Pages/OtherPages/termsConditions";
import Feedback from "./Pages/OtherPages/feedback";
import Contact from "./Pages/OtherPages/contact";
import UserGuideRoot from "./Pages/user-guide/user-manual-root.jsx";
import UserGuide from "./Pages/user-guide/index.jsx";
import AllNotification from "./Pages/OrganizationSettings/CustomAlerts/AllNotification";
import { notification } from "antd";
import { NOTIFICATION_EVENT, initializeWebSocket } from "./Services/webSocketService";

function App() {
  // Listen for WebSocket notification events and display antd notifications
  useEffect(() => {
    const handleNotification = (event) => {
      const { title, description, silent } = event.detail;

      if (silent) {
        return;
      }

      notification.open({
        message: title || "Notification",
        description: description || "",
        placement: 'topRight',
        style: {
          border: "solid",
          borderRadius: "5px",
          borderColor: "#EA4E2C",
          borderWidth: "0px 0px 0px 4px",
          backgroundColor: "#FDF0EF",
        },
        duration: 5,
      });
    };

    window.addEventListener(NOTIFICATION_EVENT, handleNotification);

    // Initialize WebSocket if user is already logged in (handles hard refresh)
    const token = localStorage.getItem("token");
    if (token) {
      initializeWebSocket();
    }

    return () => {
      window.removeEventListener(NOTIFICATION_EVENT, handleNotification);
    };
  }, []);

  return (
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route index path="/*" element={<Home />} />
          <Route path="login" element={<Login />} />
          <Route path="landing-page" element={<LandingPage />} />
          <Route path="create-account" element={<Signup />} />
          <Route path="reset-password" element={<ResetPassword />} />
          <Route path="change-password" element={<ChangePassword />} />
          <Route path="reset-verification" element={<ResetVerification />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="terms-and-conditions" element={<TermsConditions />} />
          <Route path="feedback" element={<Feedback />} />
          <Route path="contact-us" element={<Contact />} />
          <Route path="user-guide" element={<UserGuideRoot />}>
            <Route index element={<UserGuide />} />
            <Route path="edit" element={<UserGuide />} />
          </Route>
          <Route path="/all-notification" element={<AllNotification />} />

        </Routes>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
